export default function throttle(func, ms) {
  let isThrottled = false
  let savedArgs
  let savedThis

  function wrapper() {
    if (isThrottled) {
      savedArgs = arguments // eslint-disable-line prefer-rest-params
      savedThis = this
      return
    }

    func.apply(this, arguments) // eslint-disable-line prefer-rest-params

    isThrottled = true

    setTimeout(() => {
      isThrottled = false
      if (savedArgs) {
        wrapper.apply(savedThis, savedArgs)
        savedArgs = null
        savedThis = null
      }
    }, ms)
  }

  return wrapper
}
